import { cn } from "@/lib/utils";

type Props = {
  className?: string;
  fill?: string;
};

const DashboardContractorIcon = ({ className, fill = "#2A2A2A" }: Props) => {
  return (
    <svg
      className={cn("h-[18px] w-[13px] shrink-0", className)}
      viewBox="0 0 13 18"
      fill={fill || "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
    <path
      d="M12.3675 17.9939C12.3372 17.9977 12.3068 17.9999 12.2772 17.9999C11.9183 17.9999 11.607 17.7224 11.5615 17.3429C11.2307 14.5957 9.1969 12.7499 6.50007 12.7499C3.80324 12.7499 1.76943 14.5957 1.43864 17.3429C1.38881 17.7539 1.0248 18.0464 0.632627 17.9939C0.236842 17.9429 -0.0441075 17.5679 0.00572672 17.1569C0.424623 13.6792 3.09473 11.2499 6.50007 11.2499C9.90541 11.2499 12.5762 13.6792 12.9944 17.1569C13.0435 17.5679 12.7633 17.9429 12.3675 17.9939ZM1.0833 5.24997C1.0833 4.83597 1.40686 4.49998 1.80554 4.49998H2.16666V4.12498C2.16666 1.85024 3.94841 0 6.13895 0H6.86119C9.05173 0 10.8335 1.85024 10.8335 4.12498V4.49998H11.1946C11.5933 4.49998 11.9168 4.83597 11.9168 5.24997C11.9168 5.66397 11.5933 5.99997 11.1946 5.99997H10.8335C10.8335 8.4817 8.88995 10.4999 6.50007 10.4999C4.11019 10.4999 2.16666 8.4817 2.16666 5.99997H1.80554C1.40686 5.99997 1.0833 5.66397 1.0833 5.24997ZM9.38901 5.99997H3.61113C3.61113 7.65446 4.90682 8.99995 6.50007 8.99995C8.09332 8.99995 9.38901 7.65446 9.38901 5.99997ZM3.61113 4.49998H9.38901V4.12498C9.38901 2.80499 8.44577 1.70924 7.22231 1.52699V2.99998C7.22231 3.41398 6.89875 3.74998 6.50007 3.74998C6.1014 3.74998 5.77783 3.41398 5.77783 2.99998V1.52699C4.55437 1.70924 3.61113 2.80499 3.61113 4.12498V4.49998Z"
      fill={fill}
    />
    </svg>
  );
};

export default DashboardContractorIcon;
